module.exports = Object.freeze({
    reportTypeIds: {
        1: 'PRO',
        2: 'Master Performance',
        3: 'Publisher / Admin',
        4: 'Label / Distributor'
    }
});
